const emptyToUndefined = (value: string) => {
  const trimmedValue = value.trim()

  return trimmedValue || undefined
}

const normalizeWebsite = (website: string) => {
  const normalizedValue = emptyToUndefined(website)

  if (!normalizedValue) return undefined

  return normalizedValue.startsWith('http://') || normalizedValue.startsWith('https://')
    ? normalizedValue
    : `https://${normalizedValue}`
}

const buildAddress = ({
  address,
  address_second_line,
  city,
  country,
  postcode,
  region,
}: {
  address: string
  address_second_line: string
  city: string
  country: string
  postcode: string
  region: string
}) => {
  const nextAddress = {
    address: emptyToUndefined(address),
    address_second_line: emptyToUndefined(address_second_line),
    city: emptyToUndefined(city),
    country: emptyToUndefined(country),
    postcode: emptyToUndefined(postcode),
    region: emptyToUndefined(region),
  }

  return Object.values(nextAddress).some(Boolean) ? nextAddress : undefined
}

const getCompanyOverviewPath = (company: {
  id: number
  type: 'broker' | 'haulier' | 'shipper'
}) => {
  switch (company.type) {
    case 'broker':
      return `/management/brokers/${company.id}/overview`
    case 'haulier':
      return `/management/carriers/${company.id}/overview`
    case 'shipper':
      return `/management/customers/${company.id}/overview`
  }
}

const normalizeSource = (source: string): 'cargoking' | 'kcharles' => {
  return source === 'kcharles' ? 'kcharles' : 'cargoking'
}

export { buildAddress, emptyToUndefined, getCompanyOverviewPath, normalizeSource, normalizeWebsite }
